import { Checkbox } from '@/components/ui/checkbox';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { Translator } from '../translator.type';

export type Employee = {
  id: string;
  firstname: string;
  lastname: string;
  email: string;
  phoneNumber: string | null;
  createdAt: string;
};

export const employeeColumns = (t: Translator): ColumnDef<Employee>[] => [
  {
    id: 'select',
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && 'indeterminate')
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: 'lastname',
    header: t('pages.profile.employeeColumns.lastname'),
  },
  {
    accessorKey: 'firstname',
    header: t('pages.profile.employeeColumns.firstname'),
  },
  {
    accessorKey: 'email',
    header: t('pages.profile.employeeColumns.email'),
  },
  {
    accessorKey: 'phoneNumber',
    header: t('pages.profile.employeeColumns.phoneNumber'),
  },
  {
    accessorKey: 'createdAt',
    header: t('pages.profile.employeeColumns.createdAt'),
    cell: ({ row }) => (
      <span>{format(new Date(row.original.createdAt), 'dd/MM/yyyy')}</span>
    ),
  },
];
